<template>
    <div>
        <load-screen-component></load-screen-component>
        <page-header pageTitle="CONTRACT.INDEX" has-slot>
            <template #container>
                <div class="card p-2 mt-2  d-flex flex-row align-items-center header-toolbar-actions" style="border-radius: 15px;">
                    <div class="toolbar-select mr-2" v-if="widthMd(938, '>')">
                            <span class="toolbar-select-label">
                                <i class="icon-grid"></i>
                                {{ t('NAV.ALLOTMENT_S') }}:
                            </span>
                        <div class="toolbar-select-control">
                            <Select2 :settings="{ width: '100%', placeholder:  t('LOTS.ALLOTMENT')}" :options="allotments"
                                     v-model="allotmentId" @select="changeAllotment($event)"/>
                        </div>
                    </div>
                    <div class="align-self-center mr-2" >
                        <a class="btn btn-primary " id="filter" data-toggle="modal" data-target="#customModalTwo"
                           @click="setModalFilter" >
                            Filtro
                        </a>
                    </div>
                    <div class="align-self-center" v-if="this.$hasPermission('group_adm', true) && allotmentId">
                        <a class="btn btn-custom bg-btn" data-toggle="modal" data-target="#customModalTwo"
                           @click="setRegisterModal" id="new" data-cy="btn-new-page-header">
                            <i class="icon-circle-with-plus"></i> Novo
                        </a>
                    </div>
                </div>
            </template>
        </page-header>
        <div class="card mb-1" v-if="hastwoAllotments && widthMd(939, '<')">
            <div class="card-body pt-2 row">
                <div class="col-10 col-xl-3 col-md-3">
                    <label>{{ t('NAV.ALLOTMENT') }}</label>
                    <Select2 :settings="{ width: '100%', placeholder:  t('LOTS.ALLOTMENT')}" :options="allotments"
                             v-model="allotmentId" @select="changeAllotment($event)"/>
                </div>
            </div>
        </div>
        <div class="card" v-if="!data?.data?.length">
            <div class="card-header"></div>
            <div class="card-body pt-0">
                <div class="text-center">
                    <h5>{{ t('CONTRACT.NONE_FOUND') }}</h5>
                </div>
            </div>
        </div>
        <div class="pb-2" v-if="data?.data?.length ">
            <div class="data-list-card card">
                <div class="data-list-card__header">
                    <span class="data-list-card__title">{{ t('CONTRACT.INDEX') }}</span>
                    <span class="data-list-card__count">{{ data.data.length }}</span>
                </div>
                <div class="data-list-card__body">
                    <div class="table-responsive">
                        <table class="table table-hover data-list-table mb-0">
                        <thead>
                        <tr>
                            <th class="text-center">{{ this.t('CONTRACT.CONTRACT_N') }}</th>
                            <th class="text-center">{{ t('CONTRACT.STATUS_PROPOSAL') }}</th>
                            <th class="text-center">{{ t('CONTRACT.STATUS_RESERVE') }}</th>
                            <th class="text-center">{{ this.t('PROPOSAL.CLIENT') }}</th>
                            <th class="text-center">{{ this.t('PROPOSAL.REALTOR') }}</th>
                            <th class="text-center">Q.</th>
                            <th class="text-center">L.</th>
                            <th class="text-center">Assinatura</th>
                            <th class="text-center">{{ this.t('PROPOSAL.DATE_CREATE') }}</th>
                            <th class="text-center">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(iten) in data.data" :key="iten.id">
                            <td class="text-center pt-2 pb-2">
                                <span class="data-list-table__badge data-list-table__badge--primary">{{ getNumber(iten) }}</span>
                            </td>
                            <td class="text-center pt-2 pb-2">
                                <div class="font-weight-bold d-flex justify-content-center w-100"
                                     style="width: 130px;" id="status">
                                    <div class="rounded-pill pb-1 pt-1 card m-0 pl-3 pr-3 dynamic-background-card dynamic-text-color"
                                         style="min-width: 130px"
                                         :style="{'--dynamic-bg': translateColorStatus(iten.status), '--dynamic-color': 'white'}">
                                        {{ translateStatus(iten.status) }}
                                    </div>
                                </div>
                            </td>
                            <td class="text-center pt-2 pb-2">{{ iten?.reserve?.reserve_status?.name }}</td>
                            <td class="pt-2 pb-2 data-list-table__primary-text" :title="getNameClient(iten)">{{ getNameClient(iten) }}</td>
                            <td class="pt-2 pb-2 data-list-table__muted-text">{{ iten.reserve?.realtor?.name ? iten.reserve.realtor?.name : 'Indefinido' }}</td>
                            <td class="text-center pt-2 pb-2"><span class="data-list-table__badge">{{ iten.properties?.block }}</span></td>
                            <td class="text-center pt-2 pb-2"><span class="data-list-table__badge">{{ iten.properties?.name }}</span></td>
                            <td class="text-center pt-2 pb-2">
                                <div v-if="iten?.click_sign_documents_contract?.status"
                                     :style="{'--dynamic-bg': translateColorStatusAssign(iten?.click_sign_documents_contract?.status), '--dynamic-color': 'white', 'margin-bottom': '0'}"
                                     class="card text-white font-weight-bold p-1 dynamic-background-card dynamic-text-color" style="font-size: 12px">
                                    {{ getStatusClickSing(iten?.click_sign_documents_contract?.status) }}
                                </div>
                                <div v-else style="font-size: 12px"
                                >{{ getStatusClickSing(iten?.click_sign_documents_contract?.status) }}
                                </div>
                            </td>
                            <td class="text-center pt-2 pb-2">{{ endDateFormat(iten.contract_date, false) }}</td>
                            <td class="text-center pt-2 pb-2">
                                <div>
                                    <a type="button" data-toggle="dropdown" aria-haspopup="true"
                                       aria-expanded="false" class="data-list-table__action-badge" id="listDropdown">
                                        <i class="icon-more-horizontal" title="Opções"></i>
                                    </a>
                                    <div class="dropdown-menu dropdown-menu-right dropdown-black w-auto">
                                        <div class="dropdown-item pointer text-white"
                                             data-toggle="modal" data-target="#customModalTwo"
                                             v-if="(hasConfig && iten.click_sign_documents_contract?.clicksign_id && this.$hasPermission('proposal_viewSignature', true))"
                                             @click="viewDocumentClickSing(iten?.click_sign_documents_contract?.clicksign_id)">
                                            <i class="icon-eye mr-2 font-15"/>{{ 'Assinaturas' }}
                                        </div>
                                        <div class="dropdown-item pointer text-white"
                                             v-if="this.$hasPermission('proposal_reprint', true) && canSocityClickSign(iten?.click_sign_documents_contract?.status)"
                                             @click="regenerateContract(iten.id)">
                                            <i class="icon-autorenew mr-2 font-15"/>{{
                                                t('CONTRACT.REGENERATE')
                                            }}
                                        </div>
                                        <div class="dropdown-item pointer text-white"
                                             v-if="(this.$hasPermission('proposal_cancelSignature', true) && hasConfig && iten.click_sign_documents_contract?.status === 1 && iten.status === 'APROVADA')"
                                             @click="cancelClickSing(iten.id)">
                                            <i class="icon-x-circle mr-2 font-15"/>{{ t('PROPOSAL.CANCEL_CLICKSIGN') }}
                                        </div>
                                        <div class="dropdown-item pointer text-white"
                                             data-toggle="modal" data-target="#customModalTwo"
                                             v-if="this.$hasPermission('proposal_update', true) && (!iten.click_sign_documents_contract?.clicksign_id || iten.click_sign_documents_contract?.status === 3 || iten.click_sign_documents_contract?.status === 4)"
                                             @click="setModalEdit(iten.id)">
                                            <i class="icon-pencil mr-2 font-15"/>{{ t('PROPOSAL.EDIT') }}
                                        </div>
                                        <div class="dropdown-item pointer text-white"
                                             v-if="this.$hasPermission('proposal_show', true)"
                                             data-toggle="modal" data-target="#customModalTwo"
                                             @click="setModalClientAnexView(iten)">
                                            <i class="icon-people mr-2 font-15"/>{{ t('PROPOSAL.CLIENT_FICH') }}
                                        </div>
                                        <div class="dropdown-item pointer text-white"
                                             v-if="this.$hasPermission('proposal_delete', true) && (!iten.click_sign_documents_contract?.clicksign_id || iten.click_sign_documents_contract?.status === 3 || iten.click_sign_documents_contract?.status === 4)"
                                             @click="deleteContract(iten.id)">
                                            <i class="icon-trash mr-2 font-15"/>{{ t('ACTIONS.DELETE') }}
                                        </div>
                                        <div class="dropdown-item pointer text-white"
                                             v-if="this.$hasPermission('proposal_requestSignature', true) && (hasConfig && canSocityClickSign(iten?.click_sign_documents_contract?.status) && iten.status === 'APROVADA')"
                                             @click="solicitClickSing(iten.id)">
                                            <i class="icon-border_color mr-2 font-15"/>{{
                                                t('PROPOSAL.SOLICIT_CLICKSIGN')
                                            }}
                                        </div>
                                        <div class="dropdown-item pointer text-white"
                                             v-if="this.$hasPermission('proposal_show', true)"
                                             @click="reprintContract(iten)">
                                            <i class="icon-eye1 mr-2 font-15"/>{{ t('CONTRACT.VIEW') }}
                                        </div>
                                        <div class="dropdown-item pointer text-white"
                                             v-if="this.$hasPermission('proposal_show', true)"
                                             @click="reprintProposal(iten)">
                                            <i class="icon-eye1 mr-2 font-15"/>{{ t('PROPOSAL.VIEW') }}
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="row gutters">
            <div class="col-12">
                <pagination-component v-if="data?.data?.length" :items="data" :to="'/contratos'"
                                      :have-per-page="!widthMd(1000)"
                                      :per-page="perPage"
                                      :paginate="paginate"
                                      @changePaginate="changePaginate"
                                      @changePage="index(filter, $event)"></pagination-component>
            </div>
        </div>
        <div>
            <modal-select-allotment v-if="allotments" :showModal="showAllotmentSelect" scope-allotment
                                    @showModal="showAllotmentSelect = $event" @allotmentSelected="allotmentSelected">
            </modal-select-allotment>
        </div>
        <modal :modal-xl="modalChoose !== 7" :modal-x-xl="modalChoose === 7" :title-modal="modalTitle" v-if="modalChoose !== 6">
            <template v-slot:title>{{ t(modalTitle) }}</template>
            <edit-contract-component v-if="modalChoose === 1" :proposal-index="proposal"></edit-contract-component>
            <view-document-click-sign-component v-if="modalChoose === 2"
                                                 :itens-index="documentClickSing"></view-document-click-sign-component>
            <filter-contract-component v-if="modalChoose === 3" :perPageIndex="perPage"
                                        @search="filterProposal" @close="closeFilter()"></filter-contract-component>
            <listPersonDownloadFich v-if="modalChoose === 5" :clients="clientsForFich"></listPersonDownloadFich>
            <click-sign-request-review-component v-if="modalChoose === 7"
                                                 :review="clickSignReview"
                                                 :loading="clickSignReviewLoading"
                                                 @cancel="closeClickSignReview"
                                                 @confirm="confirmClickSignReview"></click-sign-request-review-component>

        </modal>
        <modal :modal-extra-large="true" :title-modal="modalTitle" v-if="modalChoose === 6" @close="closeModalCreate">
            <template v-slot:title>{{ t(modalTitle) }}</template>
            <list-proposals-for-create v-if="modalChoose === 6" :allotment-id="allotmentId"></list-proposals-for-create>
        </modal>
    </div>
</template>

<script>
import loadScreenComponent from '../../components/layouts/loadScreenComponent';
import {closePendingTab, openPendingTab, showPdfInTab} from '@/Helpers/PdfTab';
import pageHeader from '../../components/layouts/pageHeader';
import {useToast} from 'vue-toastification';
import {useI18n} from 'vue-i18n';
import Proposal from '../../services/Proposal';
import {mapState} from 'vuex';
import Select2 from 'vue3-select2-component';
import modalSelectAllotment from '../allotment/modalSelectAllotmentComponent';
import PaginationComponent from '../../components/layouts/PaginationComponent';
import modal from '../../components/modal';
import FilterContractComponent from './FilterContractComponent';
import editContractComponent from './editContractComponent';
import ConfigClickSign from '../../services/ConfigClickSign';
import ViewDocumentClickSignComponent from '../proposal/ViewDocumentClickSignComponent';
import {PDFDocument} from 'pdf-lib';
import Clients from '@/services/Clients';
import listPersonDownloadFich from '@/pages/proposal/listPersonDownloadFich';
import widthMd from '../../mixins/widthMd';
import StatusProposal from '../../mixins/StatusProposal';
import listProposalsForCreate from './listProposalsForCreate';
import UserCompanies from '../../services/UserCompanies';
import ClickSignRequestReviewComponent from '../proposal/ClickSignRequestReviewComponent';
import {Modal} from 'bootstrap';

export default {
    name: "indexContractComponent",
    components: {
        loadScreenComponent,
        pageHeader,
        modalSelectAllotment,
        Select2,
        PaginationComponent,
        modal,
        FilterContractComponent,
        editContractComponent,
        ViewDocumentClickSignComponent,
        listPersonDownloadFich,
        listProposalsForCreate,
        ClickSignRequestReviewComponent,
    },
    mixins: [widthMd, StatusProposal],
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    data() {
        return {
            allotmentId: null,
            proposal: {},
            hasConfig: false,
            showAllotmentSelect: false,
            data: {},
            documentClickSing: [],
            filter: null,
            perPage: null,
            modalTitle: null,
            modalChoose: null,
            clientsForFich: [],
            clickSignReview: {},
            clickSignReviewId: null,
            clickSignReviewLoading: false,
        }
    },
    async mounted() {
        this.$canAccess('proposal_index');
        if (sessionStorage.getItem('allotmentIdScope')) {
            this.allotmentId = sessionStorage.getItem('allotmentIdScope');
            await this.chanceCustomScope(this.allotmentId);
            this.index();
        } else if (this.allotments?.length === 1) {
            this.allotmentId = this.allotments[0].id;
            sessionStorage.setItem('allotmentIdScope', this.allotmentId);
            await this.chanceCustomScope(this.allotmentId);
            this.index();
        } else if (this.allotments?.length) {
            this.showAllotmentSelect = true;
        }
        this.checkHasConfig();
    },
    computed: {
        ...mapState(['isLoading', 'hastwoAllotments', 'allotments', 'paginate'])
    },
    watch: {
        allotments: function () {
            if (!sessionStorage.getItem('allotmentIdScope')) {
                this.showAllotmentSelect = true;
            }
        },
    },
    methods: {
        async chanceCustomScope(id) {
            await UserCompanies.chanceCustomScope(id).then(resp => {
                this.$setCustomToken(resp.data.accessToken, resp.data.refreshToken);
            }).catch(err => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(err);
            });
        },
        regenerateContract(id) {
            this.$swal.fire({
                title: `Realmente deseja atualizar o contrato?`,
                text: 'Esta ação restaura o contrato com base no template vinculado, quaisquer edições feitas no texto do contrato serão perdidas!',
                showCancelButton: true,
                showCloseButton: true,
                confirmButtonText: `Gerar`,
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store.commit('changeLoading', true);
                    Proposal.regenerateContract(id).then((resp) => {
                        this.downloadBase64PDF(resp.data, 'contrato.pdf');
                        this.toast.success(this.t('GENERAL.UPDATED_SUCCESSFULL'));
                        this.index();
                    }).catch((err) => {
                        this.$store.commit('changeLoading', false);
                        this.errorMsg(err);
                    })
                }
            });
        },
        downloadBase64PDF(base64, fileName) {
            base64 = base64.split(',')[1] || base64;
            const byteCharacters = atob(base64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], {type: 'application/pdf'});
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName || 'documento.pdf';
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        },
        closeModalCreate() {
            this.modalChoose = null;
            this.modalTitle = null;
            this.index()
        },
        setRegisterModal() {
            this.$store.commit('changeLoading', true);
            this.modalChoose = 6;
            this.modalTitle = 'Propostas para gerar contrato:';
        },
        changePaginate(perPage) {
            this.perPage = perPage;
            this.index(this.filter);
        },
        async setModalClientAnexView(iten) {
            if (iten.clients.length === 1) {
                await this.printClientPdf(iten.clients?.find(i => i).clients);
                document.getElementById('closeX')?.click();
            } else {
                this.modalChoose = 5;
                this.modalTitle = 'Download ficha do cliente';
                this.clientsForFich = iten.clients;
            }
        },
        async printClientPdf(iten) {
            this.$store.commit('changeLoading', true);
            await Clients.exportPdfClient(iten.id).then(async (response) => {
                if (response.data?.length) {
                    const mergedPdf = await PDFDocument.create();
                    for (const pdfObj of response.data) {
                        if (pdfObj?.basefile) {
                            const pdfBase64 = pdfObj.basefile;
                            const pdfBytes = this.base64ToUint8Array(pdfBase64);
                            try {
                                const pdfDoc = await PDFDocument.load(pdfBytes);
                                const copiedPages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
                                copiedPages.forEach((page) => mergedPdf.addPage(page));
                            } catch (err) {
                                const blob = new Blob([pdfBytes], {type: 'application/pdf'});
                                const url = URL.createObjectURL(blob);
                                const a = document.createElement('a');
                                a.href = url;
                                let fileName = response.data.find(i => i)?.name ? response.data.find(i => i)?.name : 'arquivoPessoas.pdf';
                                fileName = fileName?.replaceAll('.pdf', '');
                                fileName = fileName + (pdfObj?.name ? pdfObj?.name : '.pdf');
                                a.download = fileName;
                                document.body.appendChild(a);
                                a.click();
                                document.body.removeChild(a);
                                URL.revokeObjectURL(url);
                            }
                        }
                    }

                    const mergedPdfFile = await mergedPdf.save();
                    const blob = new Blob([mergedPdfFile], {type: 'application/pdf'});
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    let fileName = response.data.find(i => i)?.name ? response.data.find(i => i)?.name : 'arquivoPessoas.pdf'
                    a.href = url;
                    a.download = fileName;
                    a.style.display = 'none';
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                }
                this.$store.commit('changeLoading', false);
            }).catch((err) => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(err);
            })
        },
        base64ToUint8Array(base64) {
            const base64Data = base64.replace(/^data:application\/pdf;base64,/, '');
            const binaryString = window.atob(base64Data);
            const len = binaryString.length;
            const bytes = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            return bytes;
        },
        deleteContract(id) {
            this.$swal.fire({
                title: `Realmente deseja deletar o contrato?`,
                showCancelButton: true,
                showCloseButton: true,
                confirmButtonText: `Sim`,
                cancelButtonText: 'Não',
            }).then(result => {
                if (result.isConfirmed) {
                    this.$store.commit('changeLoading', true);
                    Proposal.deleteContract(id).then(() => {
                        this.index();
                        this.$store.commit('changeLoading', false);
                    }).catch((err) => {
                        this.$store.commit('changeLoading', false);
                        this.errorMsg(err);
                    });
                }
            });
        },
        viewDocumentClickSing(id) {
            this.$store.commit('changeLoading', true);
            Proposal.showDocumentClickSign(id).then((resp) => {
                this.modalChoose = 2;
                this.modalTitle = this.t('PROPOSAL.DOCUMENTS');
                resp.data.open = true;
                this.documentClickSing = [resp.data];
                this.$store.commit('changeLoading', false);
            }).catch((err) => {
                this.$store.commit('changeLoading', false);
                if (err.response?.data?.validations?.message) {
                    this.toast.error(err.response.data.validations.message);
                }
            });
        },
        canSocityClickSign(status) {
            if (!status) {
                return true;
            }
            switch (status) {
                case 3:
                case 4:
                case 5:
                case 7:
                    return true;
            }
            return false;
        },
        checkHasConfig() {
            ConfigClickSign.index().then(resp => {
                this.hasConfig = !!resp.data?.data?.length;
            }).catch(() => {
                this.hasConfig = false;
            })
        },
        reprintProposal(item) {
            const win = openPendingTab();
            this.$store.commit('changeLoading', true);
            Proposal.reprintProposal(item.id).then(resp => {
                this.$store.commit('changeLoading', false);
                showPdfInTab(win, resp.data);
            }).catch(() => {
                closePendingTab(win);
                this.$store.commit('changeLoading', false)
            })
        },
        solicitClickSing(id) {
            this.$store.commit('changeLoading', true);
            Proposal.previewClickSignContract(id).then((resp) => {
                this.clickSignReview = resp.data;
                this.clickSignReviewId = id;
                this.clickSignReviewLoading = false;
                this.modalTitle = 'Conferir solicitação de assinatura';
                this.modalChoose = 7;
                this.$store.commit('changeLoading', false);
                this.$nextTick(() => {
                    const modalElement = document.getElementById('customModalTwo');
                    if (modalElement) new Modal(modalElement).show();
                });
            }).catch((err) => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(err);
            });
        },
        closeClickSignReview() {
            this.clickSignReview = {};
            this.clickSignReviewId = null;
            this.clickSignReviewLoading = false;
            this.modalChoose = null;
            this.modalTitle = null;
            document.getElementById('closeX')?.click();
        },
        confirmClickSignReview() {
            if (!this.clickSignReviewId) return;
            this.clickSignReviewLoading = true;
            Proposal.solicitClickSignContract(this.clickSignReviewId).then(() => {
                this.toast.success('Assinatura de Documento requisitada com sucesso!');
                this.closeClickSignReview();
                this.index();
            }).catch((err) => {
                this.clickSignReviewLoading = false;
                this.errorMsg(err);
            });
        },
        cancelClickSing(id) {
            this.$swal.fire({
                title: `Realmente deseja cancelar assinatura ?`,
                showCancelButton: true,
                showCloseButton: true,
                confirmButtonText: `Sim`,
                cancelButtonText: 'Não',
            }).then(result => {
                if (result.isConfirmed) {
                    this.$store.commit('changeLoading', true);
                    Proposal.cancelClickSignContract(id).then(() => {
                        this.index();
                        this.toast.success('Assinatura Cancelada com sucesso!');
                    }).catch((err) => {
                        this.$store.commit('changeLoading', false);
                        if (err.response?.data?.validations?.message) {
                            this.toast.error(err.response.data.validations.message);
                        }
                    })
                }
            });
        },
        reprintContract(item) {
            const win = openPendingTab();
            this.$store.commit('changeLoading', true);
            Proposal.reprintContract(item.id).then(resp => {
                this.$store.commit('changeLoading', false);
                showPdfInTab(win, resp.data);
            }).catch(() => {
                closePendingTab(win);
                this.$store.commit('changeLoading', false)
            })
        },
        index(filter = null, page = 1, exportIn = null) {
            this.filter = filter;
            this.$store.commit('changeLoading', true);
            Proposal.indexProposalContract({
                filter: this.filter,
                allotmentId: this.allotmentId,
                page,
                perpage: this.perPage,
                exportIn
            }).then(r => {

                this.data = r.data;
                this.$store.commit('changeLoading', false);
            }).catch(() => {
                this.$store.commit('changeLoading', false);
            })
        },
        setModalEdit(id) {
            this.modalTitle = 'CONTRACT.EDIT';
            this.modalChoose = 1;
            this.$store.commit('changeLoading', true);
            Proposal.showContract(id).then((resp) => {
                this.proposal = resp.data;
                this.$store.commit('changeLoading', false);
            }).catch(() => {
                this.$store.commit('changeLoading', false);
            })
        },
        filterProposal(items, filter, allotmentId) {
            this.data = items.data;
            this.filter = filter;
            this.allotmentId = allotmentId;
        },
        closeFilter() {
            document.getElementById('closeX')?.click();
            this.filter = null;
            this.modalChoose = null;
            this.index();
        },
        getNumber(iten) {
            if (!iten?.contract_number) return '';
            const numStr = String(iten.contract_number);
            return numStr.length >= 6 ? numStr : numStr.padStart(6, '0');
        },
        getNameClient(iten) {
            let name = null;
            iten.clients.forEach((item) => {
                if (!item.clients?.name) return;
                name = name !== null ? item.clients.name + ' ,' + name : item.clients.name;
            });
            if (!name) return 'Nenhum cliente vinculado';
            return name;
        },
        endDateFormat(value, created = false) {
            if (value && !created) {
                let dateAndTime = value.split(' ');
                let date = dateAndTime[0].split('-');
                let time = dateAndTime[1].split(':');
                return `${date[2]}/${date[1]}/${date[0]} às ${time[0]}:${time[1]}`;
            } else if (value && created) {
                let dateAndTime = value.split('T');
                let date = dateAndTime[0].split('-');
                let time = dateAndTime[1].split(':');
                return `${date[2]}/${date[1]}/${date[0]} às ${time[0]}:${time[1]}`;
            }
            return 'Indefinido'
        },
        setModalFilter() {
            this.modalTitle = 'ACTIONS.FILTER';
            this.modalChoose = 3;
        },
       async changeAllotment({id}) {
            this.modalChoose = null;
            sessionStorage.removeItem('allotmentIdScope');
            sessionStorage.setItem('allotmentIdScope', id);
            this.allotmentId = id;
            await this.chanceCustomScope(this.allotmentId);
            this.index();
        },
        async allotmentSelected() {
            this.allotmentId = sessionStorage.getItem('allotmentIdScope');
            await this.chanceCustomScope(this.allotmentId);
            this.index();
        },
        setModalHoover(id) {
            document.getElementById(id).click();
        },
        toCurrency(value) {
            if (value === null) return 'Indisponível';
            return Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(value);
        },
    }
}
</script>

<style scoped>

</style>
